import { regex, required } from "common/bit/form/FormikSchema"
import * as yup from "yup"

const schemaInsurance = yup
  .object({
    firstName: yup
      .string()
      .matches(regex.singleName, "יש להזין אותיות בעברית/ באנגלית")
      .min(2, "יש להזין לפחות שתי אותיות תחת השם")
      .max(50, "יש להזין עד 50 תווים בלבד")
      .required(required.default),
    lastName: yup
      .string()
      .matches(regex.singleName, "יש להזין אותיות בעברית/ באנגלית")
      .min(2, "יש להזין לפחות שתי אותיות תחת השם")
      .max(50, "יש להזין עד 50 תווים בלבד")
      .required(required.default),
    phoneNumber: yup
      .string()
      .matches(regex.phoneNumber, "טלפון אינו תקין")
      .required("יש להזין מספר נייד תקין")
      .max(10, "יש להזין עד 10 ספרות בלבד"),
    email: yup
      .string()
      .email("כתובת מייל אינה תקינה")
      .required(required.default),
    message: yup.string().max(500, "יש להזין עד 500 תווים בלבד"),
  })
  .defined()

export const initialFormStatesInsurance: yup.InferType<typeof schemaInsurance> =
  {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    message: "",
  }

export default schemaInsurance
